import { render, staticRenderFns } from "./HelpDescription.vue?vue&type=template&id=38c916a4&scoped=true"
import script from "./HelpDescription.vue?vue&type=script&lang=js"
export * from "./HelpDescription.vue?vue&type=script&lang=js"
import style0 from "./HelpDescription.vue?vue&type=style&index=0&id=38c916a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c916a4",
  null
  
)

export default component.exports